export const INIT_CATEGORY = 'INIT_CATEGORY';
export const INIT_GALLERY = 'INIT_GALLERY';
export const INIT_PREVIEW = 'INIT_PREVIEW';
export const CLICK_CATEGORY = 'CLICK_CATEGORY';
export const CLICK_PAGER = 'CLICK_PAGER';
export const CLICK_MODAL_OPEN = 'CLICK_MODAL_OPEN';
export const CLICK_MODAL_PREV = 'CLICK_MODAL_PREV';
export const CLICK_MODAL_NEXT = 'CLICK_MODAL_NEXT';
export const CLICK_MODAL_CLOSE = 'CLICK_MODAL_CLOSE';
